import {
  AdminappPrivilege,
  AdminappRole,
  AdminappRoleScope,
} from "evangelist-db-schema/api";

export interface RoleAssignment {
  role: AdminappRole;
  scope: AdminappRoleScope;
  advertiser_id: string | null;
  privileges: AdminappPrivilege[];
}

export const hasGlobalPrivilege = (
  userRoleAssignments: RoleAssignment[],
  privilege: AdminappPrivilege,
) =>
  userRoleAssignments.some(
    (role) =>
      role.privileges.includes(privilege) &&
      role.scope === AdminappRoleScope.Global,
  );

export const hasAdvertiserPrivilege = (
  userRoleAssignments: RoleAssignment[],
  privilege: AdminappPrivilege,
  advertiserId: string,
) =>
  userRoleAssignments.some(
    (role) =>
      role.privileges.includes(privilege) &&
      (role.scope === AdminappRoleScope.Global ||
        (role.scope === AdminappRoleScope.Advertiser &&
          role.advertiser_id === advertiserId)),
  );

export const advertiserMemberRoles = [
  AdminappRole.Advertiser,
  AdminappRole.AdvertiserManager,
] as const;
